// The point of this document is for development process
export default {
  RESET: 'Reset',
  CONFIRM: 'Confirm',
  CLOSE: 'Close',
  CANCEL: 'Cancel',
  NEXT: 'Next',
  BACK: 'Return',
  VERIFY: 'Confirm',
  EDIT: 'Edit',
  SAVE: 'Save',
  SAVE_AND_APPLY: 'Save and apply',
  MANAGE: 'Manage',
  QUIT: 'Log out',
  KNOW: 'I know',
  MORE: 'More',
  DELETE: 'Delete',
  GO_TO_CHECKOUT: 'Checkout ',
  DETERMINE: 'Confirm',
  PUBLISH: 'Publish',
  VIEW_DETAIL: 'View details'
};
